import { useRef } from 'react'

// Mobile swipe-to-switch-tabs. Pass the ORDERED list of tab ids, the current id,
// and the setter. Spread the returned handlers on the tab CONTENT container:
//   const swipe = useSwipeTabs(ids, tab, setTab)
//   <div {...swipe}> … </div>
// A swipe left moves to the next tab, a swipe right to the previous one.
export function useSwipeTabs(ids, current, setCurrent) {
  const start = useRef(null)
  return {
    onTouchStart: (e) => {
      const t = e.touches[0]
      start.current = { x: t.clientX, y: t.clientY }
    },
    onTouchEnd: (e) => {
      const s = start.current
      start.current = null
      if (!s || !Array.isArray(ids) || ids.length < 2) return
      const t = e.changedTouches[0]
      const dx = t.clientX - s.x
      const dy = t.clientY - s.y
      // Require a clear, mostly-horizontal swipe so vertical scrolling is unaffected.
      if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.5) return
      const i = ids.indexOf(current)
      if (i === -1) return
      if (dx < 0 && i < ids.length - 1) setCurrent(ids[i + 1])
      else if (dx > 0 && i > 0) setCurrent(ids[i - 1])
    },
  }
}
